module.exports = __webpack_public_path__ + "static/media/LinkedCursor.e09c44dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/Features/TelestrationsVideoLibrary/Assets/LinkedCursor.png
// module id = 7504
// module chunks = 0